import { render, staticRenderFns } from "./alarm-event.vue?vue&type=template&id=214855e2&"
import script from "./alarm-event.vue?vue&type=script&lang=ts&"
export * from "./alarm-event.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-event.vue?vue&type=style&index=0&id=214855e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports